import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/*
SPDX-FileCopyrightText: 2025 Genome Research Ltd.

SPDX-License-Identifier: MIT
*/
import { useState } from "react";
import { Button, AttributeSelector, Drawer, Modal, SelectedAttributesContainer } from "../index";
import { initialiseFieldMeta } from "./Field";
function ColumnConfigDrawer(props) {
    const { baseUrl, open, setOpen, title, fieldMeta, endpoint, onConfigSave, customAttributeSelection, } = props;
    const [attributes, setAttributes] = useState(fieldMeta["order"]["active"]);
    const [initialAttributes, setInitialAttributes] = useState(fieldMeta["order"]["active"]);
    const [openSaveModal, setOpenSaveModal] = useState(false);
    const updateMeta = (id, updatedFieldMeta, hidden) => {
        const isActive = hidden ? "inactive" : "active";
        updatedFieldMeta.order[isActive].push(id);
        updatedFieldMeta.data[id] = fieldMeta.data[id];
        updatedFieldMeta.data[id].hidden = hidden;
    };
    const fieldMetaUpdatedByContents = () => {
        const updatedFieldMeta = initialiseFieldMeta();
        attributes.forEach((key) => {
            updateMeta(key, updatedFieldMeta, false);
        });
        for (const key in fieldMeta.data) {
            if (!attributes.includes(key)) {
                updateMeta(key, updatedFieldMeta, true);
            }
        }
        return updatedFieldMeta;
    };
    const saveConfig = () => {
        if (JSON.stringify(initialAttributes) !== JSON.stringify(attributes)) {
            const updatedFieldMeta = fieldMetaUpdatedByContents();
            onConfigSave(updatedFieldMeta);
            setInitialAttributes(attributes);
        }
        setOpen(!open);
    };
    const unsavedChangesModal = () => {
        return (_jsx("div", { children: _jsx(Modal, { open: openSaveModal, setOpen: setOpenSaveModal, size: "sm", children: modalContent, closeButton: false, actionButton: modalButtons }) }));
    };
    const modalContent = (_jsxs("div", { children: [_jsx("h3", { children: "Unsaved Changes" }), _jsx("p", { children: "You have an unsaved configuration, are you sure you wish to close without saving?" })] }));
    const cancelButton = (text) => {
        return (_jsx(Button, { text: text ?? "Cancel", type: "error", onClick: () => setOpenSaveModal(false) }));
    };
    const discardButton = (text) => {
        return (_jsx("div", { className: "tol-config-drawer-modal-discard-btn", children: _jsx(Button, { text: text ?? "Discard", type: "warning", onClick: () => confirmDiscard() }) }));
    };
    const saveButton = (text) => {
        return (_jsx(Button, { text: text ?? "Save", type: "success", onClick: () => {
                saveConfig(), setOpenSaveModal(false);
            } }));
    };
    const modalButtons = (_jsxs("div", { className: "tol-config-drawer-modal-btns", style: { justifyContent: "flex-end" }, children: [cancelButton(), discardButton(), saveButton()] }));
    const drawerButtons = (_jsxs("div", { className: "tol-config-drawer-modal-btns", style: { justifyContent: "space-between" }, children: [_jsx("div", { children: saveButton("Save and Close") }), _jsx("div", { children: discardButton("Discard and Close") })] }));
    const handleCloseDrawer = () => {
        if (JSON.stringify(initialAttributes) !== JSON.stringify(attributes)) {
            setOpenSaveModal(true);
        }
        else {
            setOpen(false);
        }
    };
    const confirmDiscard = () => {
        setAttributes(initialAttributes);
        setOpenSaveModal(false);
        setOpen(false);
    };
    const attSelector = (_jsxs("div", { children: [_jsx("div", { children: _jsx(AttributeSelector, { endpoint: endpoint, placeholder: "Select columns to display...", baseUrl: baseUrl, attribute: attributes, setAttribute: setAttributes, disabledValues: null, numPopulatedFields: 0, populatedFieldType: "column", additionalPopulatedFieldData: ".", recommendedFilterAvailable: true, renderSearchBySource: true, displaySource: true, customAttributeSelection: customAttributeSelection, sticky: true }) }), _jsx(SelectedAttributesContainer, { baseUrl: baseUrl, endpoint: endpoint, attributes: attributes, setAttributes: setAttributes }), _jsx("div", { children: _jsx("div", { className: "tol-config-drawer-save-button", children: drawerButtons }) })] }));
    return (_jsxs("div", { children: [unsavedChangesModal(), _jsx(Drawer, { title: title, open: open, setOpen: setOpen, children: attSelector, onClose: handleCloseDrawer })] }));
}
export default ColumnConfigDrawer;
